// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2OQeR","list":"styles_list__PHWHF"};